import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { StickyCTA } from '../components/StickyCTA';
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-279">
      <HeroSection data-id="element-280" />
      <TrustBar data-id="element-281" />

      <Suspense fallback={null} data-id="element-282">
        <div className="cv-auto" data-id="element-283">
          <ContrastSection data-id="element-284" />
          <ForWhomSection data-id="element-285" />
          <BenefitsSection data-id="element-286" />
          <ContentPreview data-id="element-287" />
          <BonusSection data-id="element-288" />
          <PricingSection data-id="element-289" />
        </div>
      </Suspense>

      <Suspense fallback={null} data-id="element-290">
        <div className="cv-auto" data-id="element-291">
          <GuaranteeSection data-id="element-292" />
          <TestimonialsSection data-id="element-293" />
          <ExpertSection data-id="element-294" />
          <FAQSection data-id="element-295" />
          <Footer data-id="element-296" />
        </div>
        <SocialProofPopup data-id="element-297" />
      </Suspense>

      <StickyCTA data-id="element-298" />
    </main>;
}